import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'line-separator',
    templateUrl: './line-separator.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ]
})
export class LineSeparatorComponent {}
